import moment from 'moment'
import * as actionTypes from './actionTypes'
import { formSeatMap } from '../../utils';
const initialState = {
  dealsList: [],
  dealData: null,
  operatorRoutes: [],
  routesMetaInfo: {},
  routeServices: [],
  sourceCityData: [],
  destCityData: [],
  seatMap: { seats: [], seatsUpper: [] },
  seatMapError: null,
  busDetails: {},
  // allRoutesInfo: {},
  metaDetails: {},
  dealsListLoading: null,
};

// isError: false, payload: {}

// for edit case, filter out all the routes which belogs to another source and destination
const filterServices = function (routeId, services) {
  // const [sourceId, destId] = routeId.split('-');
  return services.filter(el => routeId === el.route /*el.provider_source_id == sourceId && el.provider_destination_id == destId*/);
}

const getCityName = function (cityType) {
  if(cityType === 'src') {
    const sourceCity = JSON.parse(localStorage.getItem('source'));
    return sourceCity && sourceCity.name 
  }
  else if(cityType === 'dest') {
    const destCity = JSON.parse(localStorage.getItem('destination'));
    return destCity && destCity.name
  }
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.OPERATOR_DEALS_LIST:
      return { ...state, dealsList: payload.data };
    case actionTypes.OPERATOR_DEALS_LIST_LOADING:
      return { ...state, dealsListLoading: payload.data };
    case actionTypes.DEAL_DATA: {
      let services = state.routeServices;
      if (services.length && payload.data.route_id) {
        services = filterServices(payload.data.route_id, services)
      }
      return { ...state, dealData: payload.data, routeServices: services || [] }
    }

    case actionTypes.AUDIT_DEAL_DATA: {
      return { ...state, auditDealData: payload.data || [] }
    }

    case actionTypes.OPERATOR_ROUTES_LIST:
      return {
        ...state,
        [payload.fieldType === 'source' ? 'sourceCityData' : 'destCityData']: payload.data
      }

    case actionTypes.ROUTE_SERVICES: {
      let services = payload.services;
      let metaDetails = payload.metaDetails;
      if (state.dealData && state.dealData.route_id && services && services.length) {
        services = filterServices(state.dealData.route_id, services)
      }
      services = services.map(el => {
        let temp = (el.name || "").split(',');
        return {
          ...el,
          route_time_id: el.id,
          bus_type_name: temp.slice(1).join(','),
          departure_datetime: moment(temp[0], 'hh:mm').format('hh:mm a'),
          source: getCityName('src'),
          destination:getCityName('dest'),
        }
      })
      return { ...state, routeServices: services || [], metaDetails }
    }
    // needed only in deal edit mode, to get the city name from paytm_city_id
    case actionTypes.FULL_OPERATOR_ROUTES_LIST: {
      return {
        ...state,
        operatorRoutes: payload.data
      }
    }

    case actionTypes.SERVICE_SEATLAYOUT: {
      let seatMap = payload.data.body, provider_trip_id = payload.trip_id;
      let busDetails =payload.metaDetails;
      seatMap.seats = Object.keys(seatMap.seats).map((key, index) => ({
        ...seatMap.seats[key],
        rtid: busDetails.id,
      }));
      let bus = formSeatMap(seatMap, provider_trip_id)
      
      return {
        ...state,
        seatMap: bus || {},
        seatMapError: { isError: false, payload: {} },
        busDetails: busDetails,
      };
    }
    case actionTypes.THROW_SEATMAP_ERROR: {
      let error = payload.data;
      let busDetails = payload.busDetails;
      return {
        ...state,
        seatMap: {},
        seatMapError: { isError: true, payload: error },
        busDetails: busDetails,
      };
    }

    // case actionTypes.ALL_ROUTES_INFO: {
    //   return {
    //     ...state,
    //     allRoutesInfo: payload
    //   }
    // }
    case actionTypes.GET_DEAL_DATA: {
      return { ...state, getDealData: payload.data || [] }
    }

    case actionTypes.GET_SERVICE_LIST: {
      return { ...state, servicesDataList: payload.data || {} }
    }

    case actionTypes.GET_SEAT: {
      return { ...state, seatSelected: payload.data }
    }

    case actionTypes.SET_DYNAMIC_SEAT_DATA: {
      return { ...state, dynamicSeatData: payload.data }
    }

    case actionTypes.ADD_BTN_CLICKED: {
      return { ...state, addClicked: payload }
    }
      
    case actionTypes.CLEAR_DEAL_DATA:
      return initialState
      case actionTypes.GET_BENCH_MARK: {
        return { ...state, getBenchMarkData: payload.data || [] }
      }

      case actionTypes.CLEAR_BENCH_MARK: {
        return { ...state, getBenchMarkData: payload.data || [] }
      }
  
      case actionTypes.GET_TOP_ROUTES: {
        return { ...state, getTopRoutes: payload.data || [] }
      }
  
      case actionTypes.GET_AGGREGATE_DATA: {
        return { ...state, dealsWiseAggregateData: payload.data || [] }
      }
  
      case actionTypes.GET_DATE_WISE_AGGREGRATE_DATA: {
        return { ...state, dateWiseAggregateData: payload.data || [] }
      }
  
      case actionTypes.GET_DEALS_SUMMARY: {
        return { ...state, dealsSummaryData: payload.data || [] }
      }
    default:
      return state
  }
}
